<div class="dispatch-card">
  <div class="dispatch-card__guide col-6">
    <div class="guide-preview">
      <app-pdf-canvas-viewer
        *ngIf="guidePdfSrc && !guideError; else guidePlaceholder"
        [src]="guidePdfSrc"
        [zoom]="1">
      </app-pdf-canvas-viewer>
      <ng-template #guidePlaceholder>
        <div class="guide-placeholder" [class.guide-placeholder--error]="guideError && !guideLoading">
          <div class="guide-placeholder__sheet">
            <span *ngIf="guideLoading" class="guide-placeholder__spinner" aria-hidden="true"></span>
            <span class="guide-placeholder__number">{{ order.folioNumberGD || 'Guía de despacho' }}</span>
            <span *ngIf="guideLoading">Cargando guía</span>
            <span *ngIf="!guideLoading">{{ guideError ? 'No se pudo cargar la guía' : 'Vista previa no disponible' }}</span>
          </div>
        </div>
      </ng-template>
    </div>
  </div>

  <div class="dispatch-card__details">
    <div class="dispatch-card__header">
      <h2 class="dispatch-card__title">
        <ng-container *ngIf="titleNumber != null; else plainTitle">
          {{ title }} <span class="guide-number">{{ titleNumber }}</span>
        </ng-container>
        <ng-template #plainTitle>{{ title }}</ng-template>
      </h2>
      <div class="loading-info">
        <span class="field-label">Hora y boca carga:</span>
        <span>{{ toAmOrPm(order.hourOne) }} | {{ order.loadingMouth }}</span>
      </div>
    </div>


    <div class="dispatch-card__content">
      <div class="field-row">
        <span class="field-label">Fecha y hora entrega:</span>
        <span>{{ deliveryDateOnly(order.deliveryDate) }}, {{ toAmOrPm(order.startTime) }}.</span>
      </div>
      <div class="field-row">
        <span class="field-label">Obra:</span>
        <span>{{ order.workName }}</span>
      </div>
      <div class="field-row">
        <span class="field-label">Dirección:</span>
        <span>{{ order.deliveryAddress }}</span>
      </div>
      <div class="field-row" *ngIf="showAdditiveRemarks">
        <span class="field-label">Observaciones (aditivos):</span>
        <span>{{ order.additiveRemarks }}</span>
      </div>
      <div class="field-row">
        <span class="field-label">Camión:</span>
        <span>{{ order.currentTripNumber }}/{{ order.loadAmount }}</span>
      </div>
      <div class="field-row" *ngIf="showPreviousTruck">
        <span class="field-label">Camión anterior:</span>
        <span>{{ order.truckNumber }}</span>
      </div>

      <div class="section-divider"></div>
      <div class="field-row">
        <span class="field-label">Producto:</span>
        <span>{{ order.productDescription }}</span>
      </div>
      <div class="field-row">
        <span class="field-label">Cantidad a despachar:</span>
        <span>{{ order.actualQuantityShipped }} {{ order.um }}</span>
      </div>
      <div class="field-row">
        <span class="field-label">Cantidad total pedido:</span>
        <span>{{ order.scheduledAmount }}</span>
      </div>
      <div class="field-row">
        <span class="field-label">Cono:</span>
        <span>{{ order.cone }}</span>
      </div>
      <div *ngIf="order.rejectionFlag !== ''" class="field-row rejection">
        <span class="field-label">Observaciones rechazo:</span>
        <span>{{ order.rejectionFlag }}</span>
      </div>

      <div class="section-divider"></div>
      <div class="field-row">
        <span class="field-label">N° de sello:</span>
        <span>{{ order.sealNumber }}</span>
      </div>
      <div class="field-row">
        <span class="field-label">N° de guía:</span>
        <span class="guide-number">{{ order.folioNumberGD }}</span>
      </div>
      <div class="field-row" *ngIf="showOrderNumber">
        <span class="field-label">N° de pedido:</span>
        <span>{{ order.orderNumber }}</span>
      </div>

      <div class="dispatch-card__actions">
        <app-document-viewer
          #eroViewer
          class="ero-viewer"
          [codigoObra]="order.workCode"
          [label]="order.workCode">
        </app-document-viewer>
        <button type="button" class="document-action" (click)="eroViewer.open()">ERO</button>
        <button type="button" class="paper-guide-action" (click)="onPaperGuide()">Guía en papel</button>
        <button type="button" class="continue-action" [disabled]="!isActive()" (click)="onContinue()">Continuar</button>
      </div>
    </div>
  </div>
</div>
